module.exports = __webpack_public_path__ + "img/glasses-8-2.9bb3e22f.svg";